document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('.sticky-atc-panel');
  if (!panel) return;

  let lastScroll = 0;
  const threshold = 100; // Show only after scrolling 100px

  const togglePanel = () => {
    const current = window.scrollY;

    if (current > threshold) {
      if (current > lastScroll) {
        panel.classList.add('sticky-atc-panel--hidden');
      } else {
        panel.classList.remove('sticky-atc-panel--hidden');
      }
    } else {
      panel.classList.add('sticky-atc-panel--hidden');
    }

    lastScroll = current;
  };

  window.addEventListener('scroll', togglePanel);
  togglePanel(); // Initial check
});